"use strict";var isObject=require("./_is-object"),floor=Math.floor;module.exports=function(e){return!isObject(e)&&isFinite(e)&&floor(e)===e};